import { Button, HStack, Text, VStack } from "@chakra-ui/react";
import React, { memo, ReactNode } from "react";
import SyncoTooltip from "modules/_shared/synco-tooltip";
import {
  FileGalleryFragment,
  MessageFragment,
  ReactionType,
} from "gql/graphql";
import useEditMessageReaction from "modules/hooks/use-edit-message-reaction";

export interface ReactionDisplay {
  type: ReactionType;
  hasMe: boolean;
  meBackgroundColor: string;
  meBorderColor: string;
  userNameList: Array<string>;
  count: number;
  countColor: string;
  icon: ReactNode;
}

interface IProps {
  message: MessageFragment;
  file?: FileGalleryFragment;
  reaction: ReactionDisplay;
}

const MessageReaction: React.FC<IProps> = ({ message, file, reaction }) => {
  const [editMessageReactionAPI] = useEditMessageReaction(
    message,
    reaction.type,
    file?.id,
  );

  return (
    <SyncoTooltip
      // `wrapInBox` prevents a noticeable number of pixels of padding below the reaction buttons,
      // which throws off alignment for other neighboring elements (e.g. linked conversations)
      wrapInBox={false}
      label={
        <VStack align="flex-start" spacing={2}>
          <HStack spacing={2}>
            {reaction.icon}
            <Text>{reaction.type}</Text>
          </HStack>
          {reaction.userNameList.map((userName, idx) => (
            <Text key={idx}>{userName}</Text>
          ))}
        </VStack>
      }
    >
      <Button
        variant="link"
        onClick={() => editMessageReactionAPI()}
        height={6}
        backgroundColor={
          reaction.hasMe ? reaction.meBackgroundColor : undefined
        }
        minW={9}
        maxHeight="22px"
        borderRadius={reaction.hasMe ? 12 : undefined}
        borderColor={reaction.hasMe ? reaction.meBorderColor : undefined}
        borderWidth={reaction.hasMe ? 1 : undefined}
      >
        <HStack spacing={1}>
          {reaction.icon}
          <Text fontSize={11} fontWeight={700} color={reaction.countColor}>
            {reaction.count}
          </Text>
        </HStack>
      </Button>
    </SyncoTooltip>
  );
};

export default memo(MessageReaction);
